import {
  USERS_CLEAR_ERROR,
  USERS_FETCH_FAIL,
  USERS_FETCH_REQUEST,
  USERS_FETCH_SUCCESS,
} from "../constants/UserConstants";

const initialState = {
  items: [],
  loading: false,
  error: null,
};

export const UserReducer = (state = initialState, action) => {
  switch (action.type) {
    case USERS_FETCH_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case USERS_FETCH_SUCCESS:
      return {
        ...state,
        loading: false,
        items: action.payload || [],
      };
    case USERS_FETCH_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case USERS_CLEAR_ERROR:
      return {
        ...state,
        error: null,
      };
    default:
      return state;
  }
};
